const phases = [
  { n: "Phase 1", title: "Set up", desc: "Form the independent DP team and get data-protection principles adopted across the organisation." },
  { n: "Phase 2", title: "Clean up", desc: "Sort old data: delete, analyse, anonymise or encrypt. Then move everything onto India-based storage." },
  { n: "Phase 3", title: "Get prepared", desc: "Consent manager arrangements, written data policies, and reviews of new-data MIS systems." },
  { n: "Phase 4", title: "Certify", desc: "An outside agency reviews policies, data and systems, and certifies compliance. Typically 6–12 months." },
];

export const Engagement = () => (
  <section id="engagement" className="py-24">
    <div className="max-w-[1120px] mx-auto px-6">
      <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#9E1B32] bg-[#FBEAEE] px-3 py-1 rounded-full">Working with Dhwani</span>
      <h2 className="mt-4 text-3xl sm:text-4xl font-bold tracking-tight max-w-[620px]">How the engagement works</h2>
      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {phases.map((p, i) => (
          <div key={p.n} className="relative rounded-[14px] border border-[#E7E7EC] bg-white p-7 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] hover:-translate-y-0.5 transition-[box-shadow,transform]" data-testid={`phase-card-${i + 1}`}>
            <div className="w-9 h-9 rounded-full bg-gradient-to-r from-[#9E1B32] to-[#F58220] text-white grid place-items-center text-sm font-extrabold">{i + 1}</div>
            <div className="mt-4 text-xs font-bold uppercase tracking-wider text-[#9498A3]">{p.n}</div>
            <h3 className="mt-1 text-lg font-semibold">{p.title}</h3>
            <p className="mt-2 text-sm text-[#5C5F6B] leading-relaxed">{p.desc}</p>
          </div>
        ))}
      </div>
      <p className="mt-8 text-[15px] text-[#5C5F6B] max-w-[640px]">
        The outcome: an <b className="text-[#0B0B0F]">independent compliance certificate</b> you can show your board and donors.
      </p>
    </div>
  </section>
);

export default Engagement;
